var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLedBold = function SvgIconLedBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1A1F",
    d: "M.675 15v-2.65h4.65V15zM6.35 9.89 3.03 6.572l1.867-1.877 3.319 3.33zm.325 8.76V15h10.65v3.65zm4-11.65V1.35h2.65V7zm6.975 2.905-1.852-1.88 3.305-3.32 1.863 1.88zM18.675 15v-2.65h4.65V15z"
  })));
};
export default SvgIconLedBold;